import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {News,NewsService } from './news.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'ng2-meta';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}
let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.news)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(componentmodel)
{
   componentdata={templateUrl: './pg/news/news.component.html'}
}
else
{
   componentdata={template: '<div></div>'}

   
}
@Component(componentdata)
/*
@Component({
	//template: require('./news.component.html')
	templateUrl: './pg/news/news.component.html'
	
})*/

export class NewsComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public category; 
    public news:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private metaService: MetaService,
	    private _pageService: NewsService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    
	  this._sub = this._route.params.subscribe(params => {
			let slug ='news';
			this.category=slug;
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   			   
			   
			   
			   this._pageService.getNewslist(slug).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                  this.pagedata.description=data.menu.meta_description;                 
                  if(data.menu.meta_title)
                  {
	                this._title.setTitle(data.menu.meta_title);  
	                 this.metaService.setTag('og:title',data.menu.meta_title); 
                  }
                  else
                  this._title.setTitle(data.menu.link_showing_name);                  
                  this.news=data.news;
                 
                  if(data.menu.meta_description)
                   this.metaService.setTag('description',data.menu.meta_description);
                   
                   
                   this.metaService.setTag('keywords',data.menu.meta_keywords);
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/news/news.component.ts